// import * as React from 'react';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

const CssTextField = styled(TextField)(({ theme }) => ({
  '& label.Mui-focused': {
    color: theme.palette.common.searchField,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: theme.palette.common.textField,
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: theme.palette.common.textField,
    },
    '&:hover fieldset': {
      borderColor: theme.palette.common.textField,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.common.textField,
    },
  },
}));

export default CssTextField